/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Header_FooterInputs */

const en_reading_class_header_footer = /** @type {(inputs: Reading_Class_Header_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page headers and footers`)
};

const es_reading_class_header_footer = /** @type {(inputs: Reading_Class_Header_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encabezados y pies de página`)
};

/**
* | output |
* | --- |
* | "Page headers and footers" |
*
* @param {Reading_Class_Header_FooterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_header_footer = /** @type {((inputs?: Reading_Class_Header_FooterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Header_FooterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_header_footer(inputs)
	return en_reading_class_header_footer(inputs)
});